
module.cC({
    name: 'GrantIndexController',
    inject: ['$scope', 'filterFilter', 'orderByFilter', 'grants',
             'ModelService', 'permissions'],
    data: {
        grants: 'grants',
        permissions: 'permissions',

        filter: {
           type: 'all',
           query: '',
        },

        pills: [
            {name: 'All', value: 'all'},
            {name: 'Direct', value: 'direct'},
            {name: 'Passthrough', value: 'passthrough'},
        ],
    },

    listen: {
        grant: {
            create: '_addGrant',
            delete: '_deleteGrant',
        }
    },

    methods: {
        filterGrants: function(grants) {
            var filterExpression = {'$': this.filter.query};
            if (this.filter.type !== 'all') {
                filterExpression.grant_name = {
                    direct: this.filter.type === 'direct',
                }
            }
            return this.orderByFilter(
                this.filterFilter(grants, filterExpression),
                'grant_start_date', true);
        },

        _addGrant: function(grantId, programId) {
            console.log(grantId, programId);
            if (programId === this.$.program.id) {
                this.ModelService.debouncedGet('grant', grantId)
                    .then(this.ModelService.appendToArray(this.grants));
            }
        },

        _deleteGrant: function(grantId, programId) {
            if (programId === this.$.program.id) {
                this.ModelService.removeById('grant', grantId, this.grants);
            }
        },
    }
});
